<template>
	<div class="dynamicContainer">
		<!-- 导航 -->
		<div class="navBar">
			<img class="navLogo" src="../assets/logo2.png" alt="" @click="enterHome()">
			<ul class="navBarItem">
				<!-- <li><router-link to="/" exact tag="a">首页</router-link></li> -->
				<li><router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link></li>
				<el-dropdown>
					<li><router-link to="/huaiBrand" exact tag="a" style="font-size: 1em;">兰树品牌</router-link></li>
					<el-dropdown-menu class="elDropdown" slot="dropdown">
						<el-dropdown-item><router-link to="/huaiBrand" tag="a">淮树</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/brand" tag="a">心清堂</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/shuiBrand" tag="a">水姻缘</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/yiBrand" tag="a">一清堂</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/zhongBrand" tag="a">Dr.CHUNG<span
							style="vertical-align: super;">+</span></router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/lanshuBrand" tag="a">兰树</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/zbqfBrand" tag="a">植本清方</router-link></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
				<li><router-link to="/brandLanshu" exact tag="a">美业菩提</router-link></li>
				<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>
				
				<li><router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link></li>
				
				<li><router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link></li>
			</ul>
		</div>



		<img class="headerImg"
			src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-29_17-33-43_31355.jpeg" alt="">
		<!-- <div class="maskBox">	
			</div> -->



		<div class="dynamicBody">
			<div class="dynamicBox">
				<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
					<el-tab-pane align="center" label="基金会介绍" name="first">
						<div class="firstBox">
							<div class="firstBoxTop">菩提基金会由来</div>
							<div class="firstBoxText1 firstBoxText firstContent1">
								据中国出生缺陷监测网的数据统计，手足畸形的发病率近有千分之一。在常见的手足畸形中，又以拇指为多。而由于手部功能的精细性，手部畸形的矫正具有“难度大、费用高、需多次手术”的特点，而这是许多贫困家庭难以承受的，也导致很多患病儿童没有得到及时有效的治疗。
							</div>
							<div class="firstBoxText2 firstBoxText">
								为了帮助他们得到更好的救助和治疗，兰树企业特此成立了杭州兰树菩提慈善基金会。
							</div>
							<!-- <div class="firstBoxText3 firstBoxText">
									“大拇指工程”项目由温州市慈善总会、中华医学会手外科学分会、农工民主党温州市委会、温州日报报业集团、温医大附二院、中国手外科医师协会联合主办，旨在为全国患有手部先天畸形因经济困难无法及时治疗的患者，提供资助而设立的专项救助项目，是精准的医疗慈善项目。 
								</div> -->
							<div class="firstBoxImgItem">
							</div>

							<div class="firstBoxTop">菩提基金会简介</div>
							<div class="firstBoxText1 firstBoxText firstContent2">
								杭州兰树菩提慈善基金会是由兰树化妆品股份有限公司发起，在浙江省民政局注册成立的非公募基金会。基金会成立于2019年7月，注册资金200万元。<br /><br />
								自成立以来，基金会秉承“爱是正大无私的奉献”的精神，聚焦教育支持、扶贫济困、儿童发展和灾害救助等领域，以“高效、专业，创新”的工作理念，“诚信、透明”的工作态度，接受政府及公众的监督。<br /><br />
								菩提基金会积极探索可持续发展的公益模式，注重经济效益与社会效益的平衡发展，努力实现企业与社会的共赢局面。
							</div>
							<div class="firstBottom">
								<div class="firstBottomItem firstBottomItem1">
									<div class="firstBottomItemTitle">菩提基金会宗旨</div>
									<img class="firstBottomItemImg" src="../assets/dymanticLanshu/jijinhui01.jpg"
										alt="">
									<div class="firstBottomItemText">
										立足公益、面向社会，关注医疗、教育、民生等问题，关心困难群体，聚集多方公益慈善力量，积极开展助医、助学、助困项目。

									</div>
								</div>
								<div class="firstBottomItem firstBottomItem2">
									<div class="firstBottomItemTitle">菩提基金会愿景</div>
									<img class="firstBottomItemImg" src="../assets/dymanticLanshu/jijinhui02.jpg"
										alt="">
									<div class="firstBottomItemText">
										通过公益反哺社会，让公益成为一项可持续发展事业。
									</div>
								</div>
								<div class="firstBottomItem firstBottomItem3">
									<div class="firstBottomItemTitle">菩提基金会使命</div>
									<img class="firstBottomItemImg" src="../assets/dymanticLanshu/03.jpg" alt="">
									<div class="firstBottomItemText">
										助学扶贫 助医扶弱 成就他人 善行天下
									</div>
								</div>
							</div>
							<div class="firstBoxTop">理事会成员信息</div>
							<div class="firstBoxText1 firstBoxText firstContent2">
								1. 王泓锦：自2025年起担任杭州兰树菩提慈善基金会理事长，另就职于兰树化妆品股份有限公司。
							</div>
							<div class="firstBoxText1 firstBoxText firstContent2">
								2. 钟&emsp;鸣：自2025年起担任杭州兰树菩提慈善基金会副理事长，另就职于兰树化妆品股份有限公司。
							</div>
							<div class="firstBoxText1 firstBoxText firstContent2">
								3. 陈绍俊：自2025年起担任杭州兰树菩提慈善基金会秘书长。
							</div>
							<div class="firstBoxText1 firstBoxText firstContent2">
								4. 王&emsp;俊：自2025年起担任杭州兰树菩提慈善基金会理事，另就职于兰树化妆品股份有限公司。
							</div>
							<div class="firstBoxText1 firstBoxText firstContent2">
								5. 陈志伟：自2025年起担任杭州兰树菩提慈善基金会理事，另就职于兰树化妆品股份有限公司。
							</div>
							<div class="firstBoxText1 firstBoxText firstContent2">
								6. 李承霞：自2025年起担任杭州兰树菩提慈善基金会理事，另就职于兰树化妆品股份有限公司。
							</div>
							<div class="firstBoxText1 firstBoxText firstContent2">
								7. 叶玉婷：自2025年起担任杭州兰树菩提慈善基金会理事，另就职于兰树化妆品股份有限公司。
							</div>

							<div class="firstBottom">
								<div class="firstBottomItem firstBottomItem1">
									<div class="firstBottomItemTitle">理事长背景介绍</div>
									<img class="firstBottomItemImg" src="../assets/dymanticLanshu/fundManager.jpg"
										alt="">
									<div class="firstBottomItemText">
										王泓锦先生，1993年出生，毕业于亚利桑那州立大学经济学专业，现为杭州兰树菩提慈善基金会法定代表人，担任基金会理事长。另就职于兰树化妆品股份有限公司，并担任浙江锦诣投资管理有限公司监事。
									</div>
								</div>
								<div class="firstBottomItem firstBottomItem2">
									<div class="firstBottomItemTitle">秘书长背景介绍</div>
									<img class="firstBottomItemImg" src="../assets/dymanticLanshu/fundThree.jpg" alt="">
									<div class="firstBottomItemText">
										陈绍俊先生，1986年出生，毕业于华中师范大学汉口分校国际贸易专业，现担任杭州兰树菩提慈善基金会秘书长。
									</div>
								</div>
							</div>
							<div class="firstBoxTop">监事会成员信息</div>
							<div class="firstBoxText1 firstBoxText firstContent2">
								何必帅先生，1994年出生，毕业于江西理工大学，就职于浙江德名律师事务所，2025年起担任杭州兰树菩提慈善基金会监事。
								<div class="firstBottom">
								<div class="firstBottomItem firstBottomItem1">
									<div class="firstBottomItemTitle" style="margin-left: 70px">监事会成员背景介绍</div>
									<img class="firstBottomItemImg" src="../assets/dymanticLanshu/fundlawer.jpg"
										alt="">
									<div class="firstBottomItemText">
										何必帅先生，1994年出生，毕业于江西理工大学，现任杭州兰树菩提慈善基金会监事，另就职于浙江德名律师事务所
									</div>
								</div>
								<div class="firstBottomItem firstBottomItem2">
									<div class="firstBottomItemTitle"></div>
									<img class="firstBottomItemImg" alt="">
									<div class="firstBottomItemText">
									</div>
								</div>
							</div>
								
							</div>

						</div>

					</el-tab-pane>
					<el-tab-pane label="基金会新闻" name="second">
						<div class="newsBox">
							<div class="newsBoxItem" v-for="(item, index) in newsItems" :key="index"
								@click="enterDyDeatil(item.id,1)">
								<div class="newsImgMask">
									<img class="newsImg" :src="item.thumbnail_url" alt="">
								</div>
								<div class="newTitle1 busiz-text-ellipes1">{{ item.title }}</div>
								<div class="newTitle2 busiz-text-ellipes">{{ item.description }}</div>
							</div>

							<div class="paginationBox">
								<!-- 分页 -->
								<zpagenav v-bind:page="pageNum" v-bind:page-size="pageSize" v-bind:total="total"
									v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
								</zpagenav>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="基金会项目" name="third">
						<div class="newsBox">
							<div class="newsBoxItem" v-for="(item, index) in newsProjects" :key="index"
								@click="enterDyDeatil(item.id,2)">
								<div class="newsImgMask">
									<img class="newsImg" :src="item.thumbnail_url" alt="">
								</div>
								<div class="newTitle1 busiz-text-ellipes1">{{ item.title }}</div>
								<div class="newTitle2 busiz-text-ellipes">{{ item.title }}</div>
							</div>

							<div class="paginationBox">
							</div>
						</div>


						<!-- 
						<div class="dyItem">
							<div class="dyItemHeader">
								<div class="dyItemHeaderImgBox">
									<img class="dyItemHeaderImg" src="../assets/dymanticLanshu/itemImgNew1.png" alt="">
								</div>
								<div class="dyItemTitle">
									<div class="dyItemTitle1">
										扶贫救灾-齐心抗疫 公益捐款50万
									</div>
									<div class="dyItemTitle2">
      “一方有难，八方支援”，面对来势汹汹的新型冠状病毒感染的肺炎疫情，兰树企业高度重视，积极响应，以高度的社会责任感和强烈的家国情怀迅速加入到战“疫”行动中来，并在第一时间向湖北省红十字会捐款50万。<br/><br/>	
				“疫情当前，我们每个人都义不容辞，企业更该走在前面。”兰树企业董事长钟鸣先生对员工这样说道。同时钟鸣先生不忘企业初心和使命，勇担兰树企业抗击疫情总指挥，领导企业全体员工齐心共力，共克时艰。					
									</div>
								</div>
							</div>
							<div class="dyItemBottom">
								<div class="dyItemBottomTitle">
									<div class="dyItemBottomTitle1">
										儿童发展-大拇指工程 3年捐助600万
									</div>
					
									<div class="dyItemBottomTitle2">
										 善行天下·大拇指工程”大型公益慈善项目已走进新疆乌鲁木齐、云南红河以及革命圣地陕西延安等地，使近百名贫困先天性手足畸形患者得到免费治疗。<br/><br/>
										 多年来在钟鸣先生的带领下，兰树企业一直积极投身于慈善事业，2019年与温州慈善总会共同成立《大拇指慈善基金》，3年援助600万元，用于治疗全国患有手部先天畸形的患儿，同时向浙江省民政厅申请成立了《兰树菩提慈善基金会》。兰树企业将不遗余力在公益事业中贡献力量，立足公益、面向社会、关注医疗、关注教育等民生事业，聚集各方力量积极开展助医、助学等项目，让公益成为企业反哺社会的一项可持续发展的事业。<br/><br/>
										 厉兵秣马，砥砺前行，兰树企业已经做好了各项准备，将以更饱满的热情、更结实的脚步、更专业的服务迎接2021年的挑战，续写兰树企业新篇章。
									</div>
								</div>
								<div class="dyItemBottomImgBox">
									<img class="dyItemBottomImg" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_10-30-44_30554.jpg" alt="">
								</div>	
							</div>
							
						</div> 
					</el-tab-pane> -->
						<!-- <el-tab-pane label="社会荣誉" name="fourth">
						<div class="honourBox">
							<div class="firstBoxText1 firstBoxText">
								浙江兰树菩提慈善基金会成立于2019年7月，由兰树化妆品股份有限公司发起，在浙江省民政局注册成立的非公募基金会，注册资金200万元。基金会秉承“爱是正大无私的奉献”的精神，聚焦教育支持、扶贫济困、儿童发展和灾害救助等领域。
							</div>
							<div class="firstBoxText2 firstBoxText">
								2019年8月，兰树企业以菩提节出资冠名“大拇指工程”慈善公益，钟鸣先生表示，自创办企业以来，一直想参与慈善活动奉献爱心，大拇指工程为公司提供了一个行善平台。善行天下是一个企业的实力和担当，“兰树”助力大拇指工程，将分3年捐款600万元。
							</div>
							<div class="firstBoxText3 firstBoxText">
								“大拇指工程”项目由温州市慈善总会、中华医学会手外科学分会、农工民主党温州市委会、温州日报报业集团、温医大附二院、中国手外科医师协会联合主办，旨在为全国患有手部先天畸形因经济困难无法及时治疗的患者，提供资助而设立的专项救助项目，是精准的医疗慈善项目。 
							</div>
							<div class="firstBoxImgItem">
								<img class="item1 dyImg" src="../assets/dymanticLanshu/dyItem.png" alt="">
								<img class="item2 dyImg" src="../assets/dymanticLanshu/dyItem.png" alt="">
								<img class="item3 dyImg" src="../assets/dymanticLanshu/dyItem.png" alt="">
							</div>
							<div class="firstBoxText1 firstBoxText">
								浙江兰树菩提慈善基金会成立于2019年7月，由兰树化妆品股份有限公司发起，在浙江省民政局注册成立的非公募基金会，注册资金200万元。基金会秉承“爱是正大无私的奉献”的精神，聚焦教育支持、扶贫济困、儿童发展和灾害救助等领域。
							</div>
							<div class="firstBoxText2 firstBoxText">
								2019年8月，兰树企业以菩提节出资冠名“大拇指工程”慈善公益，钟鸣先生表示，自创办企业以来，一直想参与慈善活动奉献爱心，大拇指工程为公司提供了一个行善平台。善行天下是一个企业的实力和担当，“兰树”助力大拇指工程，将分3年捐款600万元。
							</div>
							<div class="firstBoxText3 firstBoxText">
								“大拇指工程”项目由温州市慈善总会、中华医学会手外科学分会、农工民主党温州市委会、温州日报报业集团、温医大附二院、中国手外科医师协会联合主办，旨在为全国患有手部先天畸形因经济困难无法及时治疗的患者，提供资助而设立的专项救助项目，是精准的医疗慈善项目。 
							</div>
							<div class="bottomText firstBoxText">
								杭州兰树菩提慈善基金会有志于传承兰树企业的公益传统和公益精神，以期用可持续的方式创造社会公益价值，带动和解决社会关切问题，通过"打造行业内具有影响力的基金会"，奉献社会，播撒爱心。								
							</div>
						</div>-->
					</el-tab-pane>




					<el-tab-pane label="联系我们" name="fifth">
						<div class="joinUsBox">
							<div class="joinUsBoxHeader">
								<div class="joinUsBoxLeft">
									<div class="joinBoxLeftTitle1">联系我们</div>
									<div class="joinBoxLeftTitle2 titleStyle1">联系电话</div>
									<div class="joinBoxLeftTitle3 titleStyle2">0571-89025888</div>
									<div class="joinBoxLeftTitle4 titleStyle1">联系邮箱</div>
									<div class="joinBoxLeftTitle5 titleStyle2">postermaster@lasur.com</div>
									<div class="joinBoxLeftTitle6 titleStyle1">联系地址</div>
									<div class="joinBoxLeftTitle7 titleStyle2">浙江省杭州市上城区越秀维多利中心 A座 17楼</div>
								</div>
								<div class="joinUsBoxRight">
									<baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler">
										<bm-info-window :position="center" title="浙江省杭州市上城区越秀维多利中心A座17楼" :show="show"
											@close="infoWindowClose" @open="infoWindowOpen">
											<p v-text="contents" class="styleContent"></p>
										</bm-info-window>
									</baidu-map>
								</div>
							</div>

							<div class="joinUsBoxBottom">
								<div class="joinUsBoxTop">
									<el-input class="nameInput" placeholder="请输入您的姓名" prefix-icon="el-icon-s-custom"
										v-model="name">
									</el-input>

									<el-input class="phoneInput" placeholder="请输入您的电话" prefix-icon="el-icon-phone"
										v-model="telephone">
									</el-input>

									<el-input class="companyInput" placeholder="请输入您公司名称"
										prefix-icon="el-icon-office-building" v-model="corporate_name">
									</el-input>

								</div>
								<div class="joinUsInputBox">
									<el-input class="needsInput" type="textarea" :rows="8" placeholder="请输入您的需求"
										v-model="demand">
									</el-input>
								</div>

								<div class="submitBtnBox">
									<el-button class="submitBtn" type="primary" @click="submit()" round>马上提交</el-button>
								</div>

							</div>


						</div>
					</el-tab-pane>
				</el-tabs>
			</div>

			<!-- 底部 -->
			<div class="footerOuter">
				<div class="footerBox">
					<div class="footerBoxHeader">
						<div class="footerBoxHeaderLeft">
							<img class="codeImg" src="../assets/code.png" alt="">
							<span class="codeText">兰树公众号</span>
						</div>
						<div class="footerBoxHeaderRight">
							<img class="codeImg" src="../assets/xcxNew.jpg" alt="">
							<span class="codeText">兰树云小程序</span>
						</div>
						<!-- <div class="footerBoxHeaderRight">
							<img class="codeImg" src="../assets/code.png" alt="">
							<span class="codeText">兰树客服(QQ)</span>
						</div> -->

					</div>
					<div class="footerMainBox">
						<li class="footerShop"><a target="_blank"
								href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
						</li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a></li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank" href="https://drchung.tmall.com" ><span>Dr.CHUNG</span>旗舰店</a></li>
						<li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
						<div class="lastHeader">
							<li><router-link to="/login" tag="a">登录</router-link></li>
							|
							<li><router-link to="/login" tag="a">注册</router-link></li>
						</div>
					</div>


					<div class="footerInfoBox">
						<div class="emailBox">邮箱: postermaster@lasur.com</div>
						<div class="phoneBox">电话: 0571-89025888</div>
						<div class="addressBox">地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
					</div>



					<div class="footerLine"></div>
					<div class="footerBoxBottom">
						<div class="footerLeft">
							Copyright © 2023 兰树化妆品股份有限公司 <a target="_blank"
								href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a> |
							<img height="16px" src="../assets/plice.png" />&nbsp;<a target="_blank"
								href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
								33052102000740号</a>
						</div>
					</div>

					<div style="width: 100%;height: 40px;"></div>

				</div>
			</div>

		</div>


	</div>
</template>

<script>
import { myGet, myPost, login } from "@/api/http";
// import { nav_js } from "../navigation/js/bootsnav.js";
export default {
	data() {
		return {
			pageNum: 1,  //显示的是哪一页
			pageSize: 6, //每一页显示的数据条数
			total: 10, //记录总数
			maxPage: 12,  //最大页数
			activeName: 'first',
			center: { lng: 0, lat: 0 },
			zoom: 3,
			show: true,
			contents: '0571-89025888',
			name: '',
			telephone: '',
			corporate_name: '',
			demand: '',
			// 新闻页内容

			newsItems: [
				// {
				//  id:1,
				//  img:require('../assets/dymanticLanshu/Bitmap1.png'),
				//  title1:'2018年上海菩提节',
				//  title2:'这里是描述这里是描述这里是描述这里是描述'
				// },
				// {
				// 	id:2,
				// 	img:require('../assets/dymanticLanshu/Bitmap2.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// },
				// {
				// 	id:3,
				// 	img:require('../assets/dymanticLanshu/Bitmap3.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// },
				// {
				// 	id:4,
				// 	img:require('../assets/dymanticLanshu/Bitmap1.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// },
				// {
				// 	id:5,
				// 	img:require('../assets/dymanticLanshu/Bitmap2.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// },
				// {
				// 	id:6,
				// 	img:require('../assets/dymanticLanshu/Bitmap3.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// },
				// {
				// 	id:7,
				// 	img:require('../assets/dymanticLanshu/Bitmap1.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// },
				// {
				// 	id:8,
				// 	img:require('../assets/dymanticLanshu/Bitmap2.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// }
			],

			newsProjects: [
				// {
				// 	id:8,
				// 	img:require('../assets/dymanticLanshu/Bitmap2.png'),
				// 	title1:'2018年上海菩提节',
				// 	title2:'这里是描述这里是描述这里是描述这里是描述'
				// }
			],

			firstDyData: [
				{
					id: 1,
					topText: '菩提基金会宗旨',
					img: require('../assets/dymanticLanshu/dyItem1.png'),
					bottomText: '立足公益、面向社会，关注医疗、教育、民生等问题，关心困难群体，聚集多方公益慈善力量，积极开展助医、助学、助困项目。'
				},
				{
					id: 2,
					topText: ' 菩提基金会愿景',
					img: require('../assets/dymanticLanshu/dyItem2.png'),
					bottomText: ' 通过公益反哺社会，让公益成为一项可持续发展事业。'
				},
				{
					id: 3,
					topText: '菩提基金会使命',
					img: require('../assets/dymanticLanshu/dyItem3.png'),
					bottomText: '助学扶贫   助医扶弱   成就他人  善行天下'
				}
			]

		}
	},
	created() {
		//   nav_js();
		this.gitSecurity()

		this.getProjects()
	},
	methods: {
		handleClick(tab, event) {
			console.log(tab, event);
		},
		// 地图
		handler({ BMap, map }) {
			console.log(BMap, map)
			this.center.lng = 120.239058;
			this.center.lat = 30.273104;
			this.zoom = 15
		},
		infoWindowClose(e) {
			this.show = false
		},
		clear() {
			this.contents = ''
		},
		infoWindowOpen(e) {
			this.show = true
		},
		enterDyDeatil(opaction,index) {
			let routeUrl = this.$router.resolve({ path: '/dyNewsDetail', query: { userId: opaction,index:index } });
			window.open(routeUrl.href, '_blank')
		},
		enterHome() {
			this.$router.push({ path: '/' });
		},
		//提交表单
		submit() {
			myPost("api/demand/", {
				name: this.name,
				telephone: this.telephone,
				corporate_name: this.corporate_name,
				demand: this.demand,
			}).then((res) => {
				if (res.data.code == 200) {
					alert('提交成功');
				}
			})
		},
		gitSecurity() {
			myPost("api/charitynewslist/", {
				pageNum: this.pageNum,
				pageSize: 6
			}).then((res) => {
				console.log("res", res)
				this.newsItems = res.data.videolist;
				this.total = res.data.total_num;
			});
		},
		pageHandler: function (page) {
			this.pageNum = page;
			myPost("api/charitynewslist/", {
				pageNum: this.pageNum,
				pageSize: 6
			}).then((res) => {
				console.log("res", res)
				this.newsItems = res.data.videolist;
				this.total = res.data.total_num;
			});
		},

		getProjects() {
			myGet("api/charitylist/", {
				// pageNum:this.pageNum,
				// pageSize:6
			}).then((res1) => {
				console.log("res1", res1)
				this.newsProjects = res1.data;
				this.total = res1.data.total_num;
			});
		},


	}
}
</script>

<style scoped>
.dynamicContainer {
	/* position:absolute;
		height: 100%;
		width: 100%;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0; */
	display: flex;
	flex-direction: column;
}

.dynamicHeader {
	display: flex;
	width: 100%;
	padding: 0;
}


.headerImg {
	width: 100%;
	margin-top: 3rem;
}

.maskBox {
	width: 100%;
	height: 500px;
	position: absolute;
	top: 55px;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
}

.dyMainBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

/* 导航 */
.navBar {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: absolute;
	justify-content: space-between;
	top: 0;
	background: #FFFFFF;
	/* border-bottom:1px solid rgba(255,255,255,0.2); */
	z-index: 999;

}

.router-link-active {
	background-color: #0F3F93 !important;
	color: #FFFFFF !important;
}

.navLogo {
	width: 10%;
	margin-left: 5em;
	cursor: pointer;
}

.navBarItem {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	/* margin-right: 8em; */

}

.navBarItem li {
	/* list-style: none;
		padding: 1.7em;
		float: left; */
	list-style: none;
	/* padding: 25px 40px 25px 40px; */
	float: left;
	/* margin-left: 2em; */
	padding-left: 0.5rem;
	padding-right: 0.5rem;
}

.navBarItem li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.3em;
	padding-bottom: 1.3em;
	padding-left: 0.8rem;
	padding-right: 0.8rem;
}


/* .elDropdown{
		margin-left: -5em;
		margin-top: -1em;
	} */


.elDropdown a {
	color: #111111;
	text-decoration: none;
}

.el-dropdown {
	vertical-align: top;
}

.el-dropdown+.el-dropdown {
	margin-left: 15px;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.menu {
	display: flex;
	flex-direction: row;
	z-index: 9999;
}

.menu span {
	color: #111111;
	font-size: 12px;
	line-height: 24px;
	padding: 0 6px;
	display: block;
	cursor: pointer;
}

.show {
	color: #fff !important;
	background: #0F3F93 !important;
}

.content {
	display: flex;
	width: 100%;
}

.dynamicBox {
	display: flex;
	flex-direction: column;
	width: 80%;
	margin: 0 auto;
	/* position: relative; */
	background: #FFFFFF;
	/* padding-bottom: 2em; */
}

.firstBox {
	display: flex;
	flex-direction: column;
	width: 75%;
	margin: 0 auto;
	margin-top: 2em;
}

.firstContent1 {
	margin-top: 1em;
}

.firstContent2 {
	margin-top: 1em;
}

.firstBoxTop {
	text-align: left;
	padding-left: 0.5em;
	border-left: 4px #0F3F93 solid;
	font-size: 1.4rem;
	font-family: MicrosoftYaHei;
	color: #111111;
	line-height: 21px;
}

.firstBottom {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 2em;
	justify-content: space-around;
	padding-bottom: 2em;
}

.firstBottomItem {
	width: 25%;
	/* align-items: center; */
}


.firstBottomItemText {
	font-size: 1em;
	font-family: MicrosoftYaHei;
	color: #333333;
	line-height: 23px;
	text-align: left;
	margin-top: 1em;
	height: 140px;
}

.firstBottomItemTitle {
	font-size: 1.1em;
	font-family: MicrosoftYaHei;
	color: #111111;
	line-height: 21px;
}


.firstBottomItemImg {
	width: 100%;
	margin-top: 1em;
}


.firstBottomItem {
	display: flex;
	flex-direction: column;
}

.honourBox {
	display: flex;
	flex-direction: column;
	width: 75%;
	margin: 0 auto;
	margin-top: 2em;
}


.el-tabs__nav-scroll {
	width: 50%;
	margin: 0 auto;
}


.dyImg {
	width: 80%;
}


.dyImg:nth-child(2) {
	margin-left: 1rem;
}


.dyImg:nth-child(3) {
	margin-left: 1rem;
}


.bottomText {
	margin-top: 1em;
	padding-bottom: 3em;
}

.firstBoxImgItem {
	display: flex;
	flex-direction: row;
	margin-top: 2em;
	padding-bottom: 2rem;
}


.firstBoxText {
	font-size: 1em;
	font-family: MicrosoftYaHei;
	color: #333333;
	line-height: 30px;
}

.firstBoxText2 {
	margin-top: 1em;
}


.firstBoxText3 {
	margin-top: 2em;
}


.dynamicBody {
	display: flex;
	flex-direction: column;
	width: 100%;
	background: #F6F6F6;
	/* position:absolute;
		 top:30em; */
}


/* 新闻 */
.newsBox {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: wrap;
	/* justify-content: space-around; */
	width: 80%;
	margin: 0 auto;
	margin-top: 2em;
	padding-bottom: 2em;
}

/* .newsBox::after{
		 flex: auto;
		 content: '';
	 } */


.newsBoxItem {
	width: 30%;
	display: flex;
	flex-direction: column;
	cursor: pointer;
	transition: 0.3s ease;
	padding-bottom: 3em;
	margin-left: 3.3%;
	position: relative;
	transform: rotate(0deg);
	/* animation: newsboxitem 1s;
		 -webkit-animation: newsboxitem 1s; */
}


/* newsboxitem 动画效果 */
@keyframes newsboxitem {
	from {
		opacity: 0;
		transform: rotate(30deg);
	}

	to {
		opacity: 1;
		transform: rotate(0deg);
	}
}

@-webkit-keyframes newsboxitem {
	from {
		opacity: 0;
		transform: rotate(30deg);
	}

	to {
		opacity: 1;
		transform: rotate(0deg);
	}
}


.newsBoxItem:hover .newTitle1 {
	color: #003F98;
}

.newsBoxItem:hover .newTitle2 {
	color: #003F98;
}


.newsBoxItem:hover .newsImg {
	transform: scale(1.5);
	transition: 0.6s ease;
}

.newsImg {
	width: 100%;
	transition: 0.6s ease;
}

.newsImgMask {
	width: 100%;
	margin: 0 auto;
	overflow: hidden;
}

.newTitle1 {
	font-size: 1em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #000000;
	line-height: 20px;
	margin-top: 1em;
}



.newTitle2 {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
	margin-top: 1em;
}



/* 分页 */
.pagination {
	display: flex;
	align-items: center;
	position: absolute;
	margin: 0 auto;
	bottom: 0em;
	padding-bottom: 1.5em;
}


/* footer */
.footerBox {
	width: 90%;
	/* height: 287px; */
	background: #F8F9FB;
	/* position:absolute;
	  	bottom:0; */
	margin: 0 auto;
	flex-direction: column;
	z-index: 999;
	margin-top: 1rem;
}


.footerOuter {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #F8F9FB;
}


.footerBoxHeader {
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 2%;
}


.footerBoxHeaderLeft {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.footerBoxHeaderRight {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderMiddle {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.codeImg {
	width: 100%;
}

.codeText {
	font-size: 0.88em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
	/* margin-top: 0em; */
}



.footerLine {
	width: 79%;
	height: 1px;
	display: flex;
	background: #000000;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 1em;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
}

.emailBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}


.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 1rem;
}


.footerLeft {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}


.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #666666;
}

.footerLeft a:hover {
	color: #003F98;
}


.footerMiddle {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}



.footerMiddle span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}

.footerRight {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerRight li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
}

.footerRight li {
	list-style: none;
}

.footerLast {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
	margin-left: 2em;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.875rm;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerLast span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
}

.footerMainBox {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 2em;
}

.footerShop {
	list-style: none;
	position: relative;
}

.footerShop span{
	margin-right: 10px;
}
.footerShop span::after{
	content: '+';
	display:block;
	position: absolute;
	top: -6px;
	right: 43px;
}

.footerShop a {
	text-decoration: none;
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	padding-left: 2em;
	line-height: 28px;
}


/* 加入我们 */
.joinUsBox {
	display: flex;
	flex-direction: column;
	align-content: space-around;
}

.joinUsBoxLeft {
	width: 40%;
	display: flex;
	flex-direction: column;
	position: relative;
	left: 0;
	animation: joinusboxleft 1s;
	-webkit-animation: joinusboxleft 1s;
	/* Safari 和 Chrome */
}


/* joinusboxleft动画效果 */
@keyframes joinusboxleft {
	from {
		opacity: 0;
		left: -20em
	}

	to {
		opacity: 1;
		left: 0;
	}
}

@-webkit-keyframes joinusboxleft {
	from {
		opacity: 0;
		left: -20em;
	}

	to {
		opacity: 1;
		left: 0;
	}
}



.joinUsBoxHeader {
	width: 80%;
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	margin-top: 3em;
}

.joinUsBoxRight {
	width: 70%;
	left: 2em;
	align-items: center;
	position: relative;
	animation: joinusboxright 1s;
	-webkit-animation: joinusboxright 1s;
}

/* joinusboxright动画效果 */
@keyframes joinusboxright {
	from {
		opacity: 0;
		left: 35em
	}

	to {
		opacity: 1;
		left: 2em;
	}
}

@-webkit-keyframes joinusboxright {
	from {
		opacity: 0;
		left: 35em;
	}

	to {
		opacity: 1;
		left: 2em;
	}
}

.joinUsBoxBottom {
	display: flex;
	flex-direction: column;
	padding-bottom: 2em;
	position: relative;
	top: 0;
	animation: joinusboxbottom 1s;
	-webkit-animation: joinusboxbottom 1s;
	/* Safari 和 Chrome */
}

/* joinusboxbottom动画效果 */
@keyframes joinusboxbottom {
	from {
		opacity: 0;
		top: 20em;
	}

	to {
		opacity: 1;
		top: 0;
	}
}

@-webkit-keyframes joinusboxbottom {
	from {
		opacity: 0;
		top: 20em;
	}

	to {
		opacity: 1;
		top: 0;
	}
}


.joinUsBoxTop {
	width: 80%;
	display: flex;
	flex-direction: row;
	align-content: space-around;
	margin: 0 auto;
	margin-top: 2em;
}


.submitBtn {
	width: 10em;
}

.submitBtnBox {
	width: 80%;
	margin: 0 auto;
	display: flex;
	margin-top: 2em;
}

.joinUsInputBox {
	width: 80%;
	display: flex;
	align-items: center;
	margin: 0 auto;
	margin-top: 3em;
}


.nameInput {
	outline: none;
}

.companyInput {
	outline: none;
}

.phoneInput {
	margin-left: 8em;
	outline: none;
}

.companyInput {
	margin-left: 8em;
	outline: none;
}

/* 地图 */
.bm-view {
	width: 100%;
	height: 339px;
}

.joinBoxLeftTitle1 {
	font-size: 1.5em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #212121;
	line-height: 48px;
	margin-top: 2em;
}

.titleStyle1 {
	font-size: 0.75em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 17px;
	margin-top: 2em;
}

.titleStyle2 {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #212121;
	line-height: 20px;
}

/* 金基会项目 */
.dyItem {
	display: flex;
	flex-direction: column;
	margin-top: 2em;
	padding-bottom: 2em;
}

.dyItemHeader {
	width: 90%;
	display: flex;
	flex-direction: row;
	margin: 0 auto;
}

.dyItemBottom {
	width: 90%;
	display: flex;
	flex-direction: row;
	margin: 0 auto;
}

.dyItemHeaderImg {
	width: 200px;
	position: relative;
	left: 0;
	animation: dyitemimg 1s;
	-webkit-animation: dyitemimg 1s;
	/* Safari 和 Chrome */
}


/* dyitemimg 动画*/
@keyframes dyitemimg {
	from {
		opacity: 0;
		/* width: 0px; */
		left: -15em;
	}

	to {
		opacity: 1;
		/* width: 200px; */
		left: 0;
	}
}

@-webkit-keyframes dyitemimg {
	from {
		opacity: 0;
		width: 0px;
		left: -15em;
	}

	to {
		opacity: 1;
		width: 200px;
		left: 0;
	}
}


.dyItemTitle {
	display: flex;
	flex-direction: column;
	left: 3em;
	top: 1em;
	padding-right: 4rem;
	position: relative;
	animation: dyitemtitle 1s;
	-webkit-animation: dyitemtitle 1s;
	/* Safari 和 Chrome */
}



/* dyitemtitle 动画*/
@keyframes dyitemtitle {
	from {
		opacity: 0;
		left: 30em;
	}

	to {
		opacity: 1;
		left: 3em;
	}
}

@-webkit-keyframes dyitemtitle {
	from {
		opacity: 0;
		left: 30em;
	}

	to {
		opacity: 1;
		left: 3em;
	}
}


.dyItemBottomTitle {
	margin-top: 3em;
	display: flex;
	width: 65%;
	flex-direction: column;
	position: relative;
	left: 0;
	animation: dybottomitemtitle 1s;
	-webkit-animation: dybottomitemtitle 1s;
	/* Safari 和 Chrome */
}


/* dybottomitemtitle 动画*/
@keyframes dybottomitemtitle {
	from {
		opacity: 0;
		left: -30em;
	}

	to {
		opacity: 1;
		left: 0;
	}
}

@-webkit-keyframes dybottomitemtitle {
	from {
		opacity: 0;
		left: -30em;
	}

	to {
		opacity: 1;
		left: 0;
	}
}



.dyItemTitle1 {
	font-size: 1.4em;
	font-family: MicrosoftYaHei;
	color: #222222;
	line-height: 19px;
}

.dyItemTitle2 {
	margin-top: 2em;
	font-size: 1em;
	font-family: MicrosoftYaHei;
	color: #666666;
	line-height: 28px;
}


.dyItemBottomImg {
	width: 220px;
	position: relative;
	z-index: 9999;
	left: 4rem;
	animation: dybottomitemimg 1s;
	-webkit-animation: dybottomitemimg 1s;
	/* Safari 和 Chrome */
}

.dyItemBottomImgBox {
	margin-top: 6rem;
	padding-right: 6rem;
}


/* dybottomitemimg 动画*/
@keyframes dybottomitemimg {
	from {
		opacity: 0;
		left: 20em;
	}

	to {
		opacity: 1;
		left: 4em;
	}
}

@-webkit-keyframes dybottomitemimg {
	from {
		opacity: 0;
		left: 20em;
	}

	to {
		opacity: 1;
		left: 4em;
	}
}


.dyItemBottomTitle1 {
	font-size: 1.4em;
	font-family: MicrosoftYaHei;
	color: #222222;
	line-height: 38px;
}


.dyItemBottomTitle2 {
	margin-top: 2em;
	font-size: 1em;
	font-family: MicrosoftYaHei;
	color: #666666;
	line-height: 28px;
}


.el-tabs__header {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
}


.el-tabs--card>.el-tabs__header {
	border-bottom: 1px solid #E4E7ED;
	width: 36%;
	margin: 0 auto;
	display: flex;
	justify-items: center;
}

.el-tabs__nav-wrap .is-top {
	display: flex;
	flex-direction: row;
	align-content: space-around;
	width: 38%;
	margin: 0 auto;
}

.firstBoxText {
	text-align: left;
}

.busiz-text-ellipes {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	/*! autoprefixer: off */
	-webkit-box-orient: vertical;
	/*autoprefixer: on */
}

.busiz-text-ellipes1 {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	/*! autoprefixer: off */
	-webkit-box-orient: vertical;
	/*autoprefixer: on */
}

.paginationBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicLanshu.vue